import { baseApi } from './baseApi'
import {
  DeviceComplaintDto,
  DeviceComplaintFileUrl,
  DeviceComplaintsCount,
  DeviceComplaintTemplate,
  FileDeviceComplaintDto,
  UpdateDeviceComplaintStatusDto,
} from 'store/types'
import { DeviceComplaintSite } from 'constants/deviceComplaints'

export const deviceComplaintsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDeviceComplaints: builder.query<
      DeviceComplaintDto[],
      { site: DeviceComplaintSite; deviceId?: number; orderId?: number; patientId?: number }
    >({
      query: ({ site, ...params }) => ({ url: `/${site}/device-complaints`, params }),
      providesTags: ['DeviceComplaints'],
    }),
    getDeviceComplaintTemplate: builder.query<DeviceComplaintTemplate, DeviceComplaintSite>({
      query: (site) => ({ url: `/${site}/device-complaints/template` }),
    }),
    getDeviceComplaintsCount: builder.query<DeviceComplaintsCount, void>({
      query: () => ({ url: `/lab/device-complaints/count` }),
      providesTags: ['DeviceComplaints'],
    }),
    getDeviceComplaintFileUrl: builder.query<DeviceComplaintFileUrl, { site: DeviceComplaintSite; id: string }>({
      query: ({ site, id }) => ({ url: `/${site}/device-complaints/${id}/url`, params: { preview: true } }),
    }),
    fileDeviceComplaint: builder.mutation<
      DeviceComplaintDto,
      FileDeviceComplaintDto & { site: DeviceComplaintSite }
    >({
      query: ({ site, ...body }) => ({ url: `/${site}/device-complaints`, method: 'POST', body }),
      invalidatesTags: ['DeviceComplaints', 'Devices'],
    }),
    updateDeviceComplaintStatus: builder.mutation<
      DeviceComplaintDto,
      UpdateDeviceComplaintStatusDto & { id: string }
    >({
      query: ({ id, ...body }) => ({ url: `/lab/device-complaints/${id}/status`, method: 'PATCH', body }),
      invalidatesTags: ['DeviceComplaints', 'Devices'],
    }),
  }),
})

export const {
  useGetDeviceComplaintsQuery,
  useGetDeviceComplaintTemplateQuery,
  useGetDeviceComplaintsCountQuery,
  useLazyGetDeviceComplaintFileUrlQuery,
  useFileDeviceComplaintMutation,
  useUpdateDeviceComplaintStatusMutation,
} = deviceComplaintsApi
